import { Component, input, output } from "@angular/core";
import { ButtonClickAsyncEvent } from "src/app/components/ui/button/button-click-async-event";

@Component({
  selector: "snt-page-toolbar-action",
  template: "",
  standalone: false
})
export class PageToolbarActionComponent {
  icon = input<string | undefined>(undefined);
  title = input<string | undefined>(undefined);
  disabled = input<boolean>(false);

  onClickAsync = output<ButtonClickAsyncEvent>();
}
